import "core-js/modules/es.array.reduce.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { useEffect, useRef, useState } from 'react';
import shallow from 'zustand/shallow';
import useStore from './../store';
import { getRoundedValue, useDebounce } from './../utils';
import { BOUNDS, DEFAULT_ROUTE, ROUTE_SET } from './../../../../constants/map';
import { UNTD_LAYERS } from './../../../../constants/layers';
import { validateRouteOption } from './utils/utils';
/**
 * Get a route parameters object based on the string
 * @param {string} path
 * @returns {object} e.g. { region: 'counties', metric: 'avg', ... }
 */

export var getParamsFromPathname = function getParamsFromPathname(path) {
  // console.log('getParamsFromPathname()')
  // strip starting "#" and "/" chars
  var route = path.replace(/^#\/+/g, ''); // Construct an object from the route, using
  // the route set ids as keys.

  var params = route.split('/').slice(0, ROUTE_SET.length - 1).reduce(function (acc, curr, i) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[ROUTE_SET[i].id] = ['zoom', 'lat', 'lon'].indexOf(ROUTE_SET[i]) > -1 ? parseFloat(curr) : curr, _extends2));
  }, {}); // console.log('params,', params)

  return params;
};
export var getStrippedRoute = function getStrippedRoute(route) {
  return route.replace(/^#[/]+/g, '').replace(/\/$/g, '');
};
export var isEmptyRoute = function isEmptyRoute(route) {
  return getStrippedRoute(route).length === 0;
};

var isLatLngValid = function isLatLngValid(lat, lng) {
  // console.log('isLatLngValid()')
  // Make sure they're inside the bounds.
  if (!lat && !lng) return true;
  lat = Number(lat);
  lng = Number(lng);
  var isValid = true;

  if (lat < BOUNDS.lat.min || lat > BOUNDS.lat.max) {
    // console.log('lat out of bounds')
    isValid = false;
  }

  if (lng < BOUNDS.lng.min || lng > BOUNDS.lng.max) {
    // console.log('lng out of bounds')
    isValid = false;
  }

  return isValid;
};

var isZoomValid = function isZoomValid(zoom) {
  // console.log('isZoomValid, ', zoom)
  if (!zoom) return true; // Make sure it's within the zoom min and max.

  return zoom > BOUNDS.zoom.min && zoom < BOUNDS.zoom.max;
};
/**
 * Validates all route params
 * @param  {Object}  params [description]
 * @return {Boolean}        [description]
 */


var isRouteValid = function isRouteValid(params) {
  // console.log('isRouteValid(), ', params, ROUTE_SET)
  var isValid = true;

  if ( // View
  !validateRouteOption(ROUTE_SET[0], params.view) || // Metric
  !validateRouteOption(ROUTE_SET[1], params.metric) || // Quintiles
  !validateRouteOption(ROUTE_SET[2], params.quintiles) || // Layers
  !validateRouteOption(ROUTE_SET[3], params.layers) || // Points
  !validateRouteOption(ROUTE_SET[4], params.points) || !isLatLngValid(params.lat, params.lng) || !isZoomValid(params.zoom)) {
    isValid = false;
  }

  console.log('hash is valid = ', isValid);
  return isValid;
};
/**
 * Constructs a comma-delineated string from array of active layers.
 * @param  {Array} activeLayers
 * @return {String}
 */


var getLayersString = function getLayersString(activeLayers) {
  // console.log('getLayersString(), ', activeLayers)
  return activeLayers.toString();
};

var RouteManager = function RouteManager(props) {
  // console.log('RouteManager!!!!!')
  // track if initial route has loaded
  var isLoaded = useRef(false); // Generic store value setter.

  var _useStore = useStore(function (state) {
    return {
      setStoreValues: state.setStoreValues,
      // Active view type.
      activeView: state.activeView,
      // Metric.
      activeMetric: state.activeMetric,
      // Active standard deviations.
      activeQuintiles: state.activeQuintiles,
      activeLayers: state.activeLayers,
      viewport: state.viewport,
      setViewport: state.setViewport,
      indicators: state.indicators,
      activePointTypes: state.activePointTypes,
      allDataLoaded: state.allDataLoaded,
      activeStaticLayers: state.activeStaticLayers
    };
  }, shallow),
      setStoreValues = _useStore.setStoreValues,
      activeView = _useStore.activeView,
      activeMetric = _useStore.activeMetric,
      activeQuintiles = _useStore.activeQuintiles,
      activeLayers = _useStore.activeLayers,
      viewport = _useStore.viewport,
      setViewport = _useStore.setViewport,
      indicators = _useStore.indicators,
      activePointTypes = _useStore.activePointTypes,
      allDataLoaded = _useStore.allDataLoaded,
      activeStaticLayers = _useStore.activeStaticLayers;
  /**
   * Returns a hash based on state
   * @return {String} [description]
   */


  var getHashFromState = function getHashFromState() {
    // console.log('getHashFromState')
    var hash = activeView + '/' + activeMetric + '/' + activeQuintiles.toString() + '/' + getLayersString(activeLayers) + '/' + getLayersString(activeStaticLayers) + '/' + activePointTypes.toString() + '/' + getRoundedValue(viewport.latitude, 4) + '/' + getRoundedValue(viewport.longitude, 4) + '/' + getRoundedValue(viewport.zoom, 2) + '/';
    return hash;
  }; // get the route params based on current view


  var route = getHashFromState(); // debounce the route so it updates every 1 second max

  var debouncedRoute = useDebounce(route, 500);
  /**
   * Sets state from route params
   * @param {[type]} params [description]
   */

  var setStateFromHash = function setStateFromHash(params) {
    // console.log('setStateFromHash(), ', params)
    if (!!params.view) {
      setStoreValues({
        activeView: params.view
      });
    }

    if (!!params.metric) {
      setStoreValues({
        activeMetric: params.metric
      });
    }

    if (params.quintiles && params.quintiles.length > 0) {
      var quintiles = params.quintiles.split(',');
      setStoreValues({
        activeQuintiles: quintiles.map(function (el) {
          return Number(el);
        })
      });
    }

    if (params.layers && params.layers.length > 0) {
      var getLayers = params.layers.split(',');
      setStoreValues({
        activeLayers: getLayers.map(function (el) {
          return Number(el);
        })
      });
    }

    if (params.static_layers && params.static_layers.length > 0) {
      var _getLayers = params.static_layers.split(',');

      setStoreValues({
        activeStaticLayers: _getLayers.map(function (el) {
          return Number(el);
        })
      });
    }

    if (params.points && params.points.length > 0) {
      var getPoints = params.points.split(',');
      setStoreValues({
        activePointTypes: getPoints.map(function (el) {
          return Number(el);
        })
      });
    }

    var resetViewport = false;

    if (!!params.lat && !!params.lng) {
      viewport.latitude = Number(params.lat);
      viewport.longitude = Number(params.lng);
      resetViewport = true;
    }

    if (!!params.zoom) {
      viewport.zoom = Number(params.zoom);
      resetViewport = true;
    }

    if (!!resetViewport) {
      setViewport(viewport);
    }
  }; // update the hash when debounced route changes


  useEffect(function () {
    // console.log('debounced route changed')
    // only change the hash if the initial route has loaded
    if (isLoaded.current) {
      // window.location.hash = '#/' + debouncedRoute
      window.history.replaceState({
        hash: '#/' + debouncedRoute
      }, 'Explorer state update', window.location.origin + window.location.pathname + '#/' + debouncedRoute);
      localStorage.setItem('untd_hash', '#/' + debouncedRoute);
      setStoreValues({
        shareHash: '#/' + debouncedRoute
      });
    }
  }, [debouncedRoute]);
  useEffect(function () {
    function loadRoute() {
      return _loadRoute.apply(this, arguments);
    }

    function _loadRoute() {
      _loadRoute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var path, params, localStorageHash, lsparams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(allDataLoaded !== true)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                isLoaded.current = true; // Get path.

                path = window.location.hash; // Construct params object from hash.

                params = getParamsFromPathname(path);
                localStorageHash = localStorage.getItem('untd_hash');

                if (!isEmptyRoute(path) && isRouteValid(params, indicators)) {
                  // Update state based on params
                  // console.log('setting state from hash params')
                  setStateFromHash(params);
                } else if (!!localStorageHash) {
                  if (localStorageHash.length > 0) {
                    lsparams = getParamsFromPathname(localStorageHash);

                    if (isRouteValid(lsparams, indicators)) {
                      // console.log('setting state from local storage')
                      setStateFromHash(lsparams);
                    }
                  }
                }

                if (isEmptyRoute(path) && !localStorageHash) {
                  // console.log('showing intro modal')
                  setStoreValues({
                    showIntroModal: true
                  });
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadRoute.apply(this, arguments);
    }

    loadRoute();
  }, [allDataLoaded]); // this component doesn't render anything

  return null;
};

export default RouteManager;